import * as Flags from "country-flag-icons/react/3x2";
import type { ComponentType, SVGProps } from "react";

const FLAG_COMPONENTS = Flags as Record<
  string,
  ComponentType<SVGProps<SVGSVGElement>>
>;

interface CountryFlagProps {
  country: string;
  className?: string;
}

export function CountryFlag({ country, className }: CountryFlagProps) {
  const Component = FLAG_COMPONENTS[country];
  if (!Component) return null;
  return (
    <Component className={className} aria-hidden="true" />
  );
}
